import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { toolkitItems } from '../data/toolkit';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Toolkit() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" aria-label="The Complete Praxis Decision Toolkit" data-id="element-325" data-mp="1wl2q83rp3c5">
      <div className="mx-auto max-w-6xl" data-id="element-326" data-mp="3t8eeq7qac0hj">
        <SectionHeading eyebrow="Also included: The Complete Praxis Decision Toolkit™" title="More Than 30 Practical Tools to Help You Organize Your Reasoning" intro="Alongside the six volumes, you’ll receive a collection of practical resources designed to help you put the framework into use." data-id="element-327" data-mp="av6t2pfhdmnh" />

        <ul className="mt-12 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-328" data-mp="fw48iu93w2la">
          {toolkitItems.map(t => <li key={t.title} className="flex gap-3 border-t border-line py-6" data-id="element-329" data-mp="2mliwi48i29st">
              <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-ok" aria-hidden="true" data-id="element-330" data-mp="2hnhb3cnlpye6" />
              <div data-id="element-331" data-mp="201iaujnhbbb0">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-332" data-mp="2021t61h1k1pk">{t.title}</h3>
                <p className="mt-1.5 leading-relaxed text-ink/70" data-id="element-333" data-mp="242bz5e4u2s4f">{t.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-mist p-6 text-center sm:p-8" data-id="element-334" data-mp="2drlrmv3lact2">
          <p className="font-heading text-xl font-medium leading-snug text-ink sm:text-2xl" data-id="element-335" data-mp="2dtggullw8r2y">
            Imagine having a structured reference you can return to whenever a pediatric praxis case feels difficult to
            organize.
          </p>
          <p className="mt-3 leading-relaxed text-ink/70" data-id="element-336" data-mp="2rsg3xotrcxx0">
            Instead of wondering where to begin, you’ll know what you know, what you don’t know, and what you may need to
            investigate next.
          </p>
        </div>
        <SectionCta label="Get the complete Praxis Decision Toolkit™" data-id="element-337" data-mp="xfgj9haitdiv" />
      </div>
    </section>;
}